import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformUserConsent } from './user-consent.transformers';
import type { UserConsentCollection } from './user-consent.types';

export function userConsentReducer(
  state: CollectionStateSlice<UserConsentCollection> = {},
  action: CollectionActions<UserConsentCollection>,
): CollectionStateSlice<UserConsentCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'userConsent') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<UserConsentCollection>(
          state,
          transformIntoDocuments(result, transformUserConsent),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'userConsent') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<UserConsentCollection>(
          state,
          transformIntoDocuments([result], transformUserConsent),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
